import styled from 'styled-components';

export const DetailsContainer = styled.div`
  overflow: auto;
  scrollbar-width: thin;
  width: 100%;
  max-width: 888px;
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.background.light};
`;

export const DetailsHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 24px 48px;
  background-color: ${({ theme }) => theme.colors.background.light};
`;

export const HeaderTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
`;

export const HeaderIconsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 12px;
`;

export const HeaderSourceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const HeaderSourceIcon = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  svg {
    display: block;
  }
`;

export const HeaderIcon = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;

  svg {
    display: block;
  }
`;

export const ReportTitle = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Country = styled.span`
  color: ${({ theme }) => theme.colors.active};
`;
